import CheckboxInput from 'components/common/Forms/CheckboxInput';
import {
  TimePlanningDesc,
  TimePlanningItemColor,
  TimePlanningList,
  TimePlanningListItem,
  TimePlanningTitle,
} from 'components/common/Tooltips/Tooltips.styled';
import { TimePlanningTooltipWrapper } from 'components/common/Tooltips/TimePlanningTooltipWrapper';
import React, { Fragment, ReactElement } from 'react';
import { TimePlanningWrapper } from './index.styled';
import { useCommonTranslation } from '../../../../../hooks/i18n/useCommonTranslation';
import InfoMessage from '../../../../common/InfoMessage';
import { FaInfoCircle } from 'react-icons/fa';

interface Props {
  setShowOnline: React.Dispatch<React.SetStateAction<boolean>>;
  showOnline: boolean;
  showOnlineMustBeShown: boolean;
}

export const TimePlanningHeader = ({
  showOnline,
  setShowOnline,
  showOnlineMustBeShown,
}: Props): ReactElement => {
  const { t } = useCommonTranslation();

  return (
    <TimePlanningWrapper>
      {showOnlineMustBeShown ? (
        <InfoMessage
          type="info"
          icon={<FaInfoCircle />}
          text={t('time-planning-must-show-online')}
          style={{
            marginBottom: 'var(--s2)',
            marginLeft: 'var(--s2)',
          }}
        />
      ) : (
        <CheckboxInput
          name="show_online"
          label={t('show-online-time')}
          style={{ marginLeft: 'var(--s3)' }}
          checked={showOnline}
          onChange={(e) => setShowOnline(e.target.checked)}
        />
      )}
      <TimePlanningTooltipWrapper minWidth={222}>
        <Fragment>
          <TimePlanningTitle>{t('planning-legend')}</TimePlanningTitle>
          <TimePlanningList>
            <TimePlanningListItem>
              <TimePlanningItemColor
                style={{
                  background: 'var(--yellowaction)',
                }}
              />
              {t('planning-legend-1')}
            </TimePlanningListItem>
            <TimePlanningListItem>
              <TimePlanningItemColor
                style={{
                  background: 'var(--greenprimary)',
                }}
              />
              {t('planning-legend-2')}
            </TimePlanningListItem>
            <TimePlanningListItem>
              <TimePlanningItemColor
                style={{
                  background: 'var(--greenprimary)',
                }}
              />
              {t('planning-legend-3')}
            </TimePlanningListItem>
          </TimePlanningList>
          <TimePlanningDesc>{t('planning-legend-4')}</TimePlanningDesc>
        </Fragment>
      </TimePlanningTooltipWrapper>
    </TimePlanningWrapper>
  );
};
